import { Optional } from "common/utils/types";

import { IProductItem } from "client/products/types";
import Banner from "client/common/components/content/Banner";

import { usePromotionDrawer } from "../stackables";

type ProductLinePromotionsProps = { item: Optional<IProductItem> };

const ProductLinePromotions = ({ item }: ProductLinePromotionsProps) => {
  const { open: openPromotionDrawer } = usePromotionDrawer();

  if (!item) {
    return null;
  }

  return (
    <>
      {item.incentives.map((incentive) => (
        <Banner.LinkButton
          type="button"
          variant="promotion-dark"
          onClick={() => openPromotionDrawer(incentive)}
          key={incentive.id}
        >
          <Banner.Content label={incentive.title} description={incentive.description} />
        </Banner.LinkButton>
      ))}
      {item.rebates.map((rebate) => (
        <Banner.LinkButton
          type="button"
          variant="promotion-dark"
          onClick={() => openPromotionDrawer(rebate)}
          key={rebate.id}
        >
          <Banner.Content label={rebate.title} description={rebate.description} />
        </Banner.LinkButton>
      ))}
    </>
  );
};

export default ProductLinePromotions;
